<template>
<div>
  <Breadcrumb :title="'Direct Investment'"></Breadcrumb>
  <DirectInvestmentForm :ref="'DirectInvestmentForm'"  :DirectInvestmentInfo="DirectInvestmentJSON" :DirectInvestmentModalLabel="modalConfig" @SaveComplete="refreshGrid">
  </DirectInvestmentForm>
  <div>
    <BaseSearchBar :config="search" @keyupSearch="filterGrid"></BaseSearchBar>
  </div>
  <div class='btnDiv'>
    <BaseToolBar :config="ToolbarConfig" @buttonClicked="toolbarOnClick"></BaseToolBar>
  </div>
  <div>
    <BaseGrid :config="GridConfig" :excelExport="excelExport" :mode="'editform'" @EditItem="EditDirectInvestment" :data="DirectInvestmentInfoData"  ></BaseGrid>
  </div>
</div>
</template>

<script>
import $ from 'jquery';
import { GridConfig, ToolbarConfig }  from "./DirectInvestmentValuationConfig.js";
import BaseModelDirectInvestmentValuation from "@/models/BaseModelDirectInvestmentValuation.js";
import BaseModelInputControl  from "@/models/BaseModelInputControl.js";
import Breadcrumb from "@/components/layout/Breadcrumb.vue";
import BaseGrid from "@/components/base/BaseGrid.vue";
import apiUtil from "@/services/apiUtil.js";
import funcUtil from "@/services/funcUtil.js";
import BaseSearchBar from "@/components/base/BaseSearchBar.vue";
import BaseToolBar from "@/components/base/BaseToolbar.vue";
import toolbarUtility from "@/services/toolbarUtility.js";
import DirectInvestmentForm from "@/components/forms/DirectInvestmentForm.vue";
import BaseModelUnitClass from "@/models/BaseModelUnitClass.js";
import BaseModelProgram from "@/models/BaseModelProgram.js";
import {mapGetters, mapActions, mapState } from 'vuex';

export default {
  name: "DirectInvestmentValuation",
  mixins: [apiUtil, funcUtil, toolbarUtility],
  components: {
    Breadcrumb,
    BaseGrid,
    BaseSearchBar,
    BaseToolBar,
    DirectInvestmentForm
  },
   computed: {
    ...mapGetters("getModule",["withFilter","getLocalInputControls"]),
    ...mapState("postModule",["response"]),
     
  },
  data: function () {
    return {
      GridConfig: GridConfig,
      grid: $("#" + GridConfig.grid.gridId).data("kendoGrid"),
      search: {
        SearchData: "",
      },
      DirectInvestmentGridId: "DirectInvestmentGrid",
      DirectInvestmentMasterData: {},
      ToolbarConfig: ToolbarConfig,
      BaseModelDirectInvestmentValuation: BaseModelDirectInvestmentValuation,      
      BaseModelUnitClass: BaseModelUnitClass,
      BaseModelInputControl:BaseModelInputControl,
      BaseModelProgram: BaseModelProgram,
      modalConfig: {
        modalName: "",
        modalAddorEdit: ""
      },
      DirectInvestmentJSON:  {       
      },
      // DirectInvestmentAddJSON: {
      //Id: "",
      // BusinessEvent:"",
      // ProgramId:"",
      // ReceiverId:"",
      // ProgramTitle:"",
      // ReceiverFullName:"",
      // UnitClass:"",
      // UnitType:"",
      // UnitPool:"",
      // Unit:"",
      // TransactionDate:"",                        
      // },
      DirectInvestmentEditJSON: {
        Id: "",
        PartnerId:"",
        PartnerPartnerID:"",
        PartnerFullName:"",
        InvestmentId:"",
        InvestmentInvestmentID:"",
        InvestmentTitle:"",
        TaxYear:"",
        TaxQuarter:"",
        CommitmentFunded:"",
        CommitmentRemaining:"",
        PriorCashDistribution:"",
        ProjectedValue:"",
        CurrentValue:"",
        Note: "",
      },
      DirectInvestmentData:[],
      DirectInvestmentValuationData:[],
      DirectInvestmentInfoData:[],    
      dropdowns: {
        TaxPeriod: { model: "", dataSource: [] },        
      },
      
     
    }
  },
  mounted() {
    const self = this;
    console.log(self.grid)
    //changes for Toolbar    
    self._loadGridSettings(self.DirectInvestmentGridId);
    $("#dropdownPeriodAllocation").bind("change",self.PeriodChangedEventHandler); 

    //get the data from DirectInvestmentValuation and DirectInvestmentValuation table. Combine to form the DirectInvestmentValuation Info Grid    
    self.getCombinedDirectInvestmentData();
    self.getInputControls(); 
    
    //bind databound event to grid
    const grid = $("#DirectInvestmentGrid").data("kendoGrid");
    grid.bind("dataBound", self.UpdateDirectInvestmentMasterData);
    // grid.dataSource.fetch();

    
        
    
  },
  methods: {
    ...mapActions("postModule",['DeleteItem']),

    PeriodChangedEventHandler(e){
      if(e != null && e!=undefined){
        e.preventDefault();
      }
      let self = this;      
      // alert($('#dropdownPeriodAllocation').val());
      var selectedPeriod = $('#dropdownPeriodAllocation').val();
      if(selectedPeriod != null && selectedPeriod != undefined){           
        self.DirectInvestmentInfoData=[];
        let IVTaxYearQuarterFilteredData = self.DirectInvestmentData.filter(item =>{return item.TaxYearQuarter == selectedPeriod});
        self.DirectInvestmentInfoData=IVTaxYearQuarterFilteredData;

        // self.DirectInvestmentData.forEach(DirectInvestmentItem => {
        //   let IVFilteredData = self.DirectInvestmentData.filter(item =>{return item.PartnerId == DirectInvestmentItem.PartnerId && item.InvestmentId == DirectInvestmentItem.InvestmentId });
        //   let DirectInvestmentCombinedItem = DirectInvestmentItem;
        //   DirectInvestmentCombinedItem.CommitmentFunded="";
        //   DirectInvestmentCombinedItem.CommitmentRemaining="";
        //   DirectInvestmentCombinedItem.PriorCashDistribution="";         
        //   DirectInvestmentCombinedItem.ProjectedValue="";
        //   DirectInvestmentCombinedItem.CurrentValue=""; 
        //   let IVTaxYearQuarterFilteredData = IVFilteredData.filter(item =>{return item.TaxYearQuarter == selectedPeriod});
        //   if(IVTaxYearQuarterFilteredData.length > 0){
        //     DirectInvestmentCombinedItem.CommitmentFunded=IVTaxYearQuarterFilteredData[0].CommitmentFunded;
        //     DirectInvestmentCombinedItem.CommitmentRemaining=IVTaxYearQuarterFilteredData[0].CommitmentRemaining;
        //     DirectInvestmentCombinedItem.PriorCashDistribution=IVTaxYearQuarterFilteredData[0].PriorCashDistribution;    
        //     DirectInvestmentCombinedItem.ProjectedValue=IVTaxYearQuarterFilteredData[0].ProjectedValue;
        //     DirectInvestmentCombinedItem.CurrentValue=IVTaxYearQuarterFilteredData[0].CurrentValue;
        //   }                   
        //   self.DirectInvestmentInfoData.push(DirectInvestmentCombinedItem);
        // });              
      }
      // else{
      //   self.getDefaultPeriodDirectInvestmentData();
      // }

    },

    getInputControls() {
      let self = this;
      let response = self.getLocalInputControls(
        self.BaseModelInputControl.list
      );
      // self._getInputControls().then(response => {
        console.log(response);
        Object.keys(self.dropdowns).forEach(key => {
          self.dropdowns[key].dataSource = response[key];
          // self.dropdowns[key].filter = self._setDropdownFilter(response[key]);
        });

        //Filling the Drop down options for the Grid DropDown Columns
        // this.toolbarDropDowns.TaxPeriod= this.dropdowns.TaxPeriod.dataSource;
        // let options = '<option value="1">One</option>';
        
        // $('#dropdownPeriodAllocation').empty();
        // let options ='';
        // if(self.dropdowns.TaxPeriod.dataSource.length > 0){
        //   for (let index = 0; index < self.dropdowns.TaxPeriod.dataSource.length; index++) {
        //     const optionvalue = self.dropdowns.TaxPeriod.dataSource[index];
        //     //select the recent value
        //     if(self.dropdowns.TaxPeriod.dataSource.length - index == 1){
        //       options = options +  '<option value="'+ optionvalue.Option +'" selected >'+ optionvalue.Option +'</option>';
        //     }else{
        //       options = options +  '<option value="'+ optionvalue.Option +'">'+ optionvalue.Option +'</option>';
        //     }   
        //   }               
        //   $('#dropdownPeriodAllocation').append(options);
         if(self.dropdowns.TaxPeriod.dataSource.length>0)
        {
         self.dropdowns.TaxPeriod.dataSource= _.orderBy(self.dropdowns.TaxPeriod.dataSource,['Option'], ['asc']);
        }
             
         $("#dropdownPeriodAllocation").kendoDropDownList({
            dataSource: self.dropdowns.TaxPeriod.dataSource,
            dataTextField: "Option",
            dataValueField: "Option"
        });
        if(self.dropdowns.TaxPeriod.dataSource.length > 0){
        // get a reference to the dropdown list and assign the latest value
        let dropdownlist = $("#dropdownPeriodAllocation").data("kendoDropDownList");
        dropdownlist.select(self.dropdowns.TaxPeriod.dataSource.length-1);

        self.PeriodChangedEventHandler();
       }else{
        //   self.getDefaultPeriodDirectInvestmentData();
        //display the empty grid if the Period dropdown is not having the proper values
        self.DirectInvestmentInfoData=[];
       }
      // });      
    },

    getCombinedDirectInvestmentData: function(){
      const self = this;
      // self._getItems(BaseModelDirectInvestmentValuation).then( (response) => {
      //   console.log('allocations ', response)
      //   self.DirectInvestmentData = response;        
      //   self.getInputControls();
      // }); 
      self.DirectInvestmentData = this.withFilter(BaseModelDirectInvestmentValuation.list);
      // self.getInputControls();
      self.PeriodChangedEventHandler();
    },

     getDefaultPeriodDirectInvestmentData: function(){
      //get the data from DirectInvestmentValuation and DirectInvestmentValuation table. Combine to form the DirectInvestmentValuation Info Grid    
      this.DirectInvestmentInfoData=[];
      this.DirectInvestmentData.forEach(DirectInvestmentItem => {
        let DirectInvestmentCombinedItem = DirectInvestmentItem;
        DirectInvestmentCombinedItem.CommitmentFunded="";
        DirectInvestmentCombinedItem.CommitmentRemaining="";
        DirectInvestmentCombinedItem.PriorCashDistribution="";         
        DirectInvestmentCombinedItem.ProjectedValue="";
        DirectInvestmentCombinedItem.CurrentValue="";     
        this.DirectInvestmentInfoData.push(DirectInvestmentCombinedItem);
      });       
    },

    UpdateDirectInvestmentMasterData: function (fromFilter, filterMasterData) {
      if (fromFilter == true) {
        this.DirectInvestmentMasterData = filterMasterData;
      } else {
        this.DirectInvestmentMasterData = JSON.parse(JSON.stringify($("#DirectInvestmentGrid").data().kendoGrid.dataSource.data()));
      }
    },

    toolbarOnClick: function (e) {
      e.preventDefault();
      switch (e.id) {
        case "btnAddDirectInvestment":
          this.AddDirectInvestment();
          window.$("#BaseModal").modal("toggle");
          break;      
        case "btnBulkImportAllocation":
          // this._AlertPopup("Bulk import screen is in progress...");   
          this.$router.push("/valuation/directinvestment/upload");       
          break;   
        case "btnRefresh":
          this.refreshGrid();
          break;
      }
      this._baseToolBarEvents("DirectInvestmentGrid", ...arguments);
    },
    refreshGrid: function(){  
      // console.log("refresh grid allocation");   
      this.getCombinedDirectInvestmentData();    
        // $("#DirectInvestmentGrid").data().kendoGrid.dataSource.read();
        // alert("Data Refreshed!");

    },
   
    filterGrid: function () {
      let self = this;
      // this.ProgramInfoFormJSON = $("#programGrid").data().kendoGrid.dataSource.view()
      // var displayedData = $("#programGrid").data().kendoGrid.dataSource.view()
      //Then stringify it as follows:
      // var displayedDataAsJSON = JSON.stringify(displayedData); 
      //alert(displayedDataAsJSON );
      var currentMasterdata = this.DirectInvestmentMasterData;

      let filteredData = this._filterGrid(this.DirectInvestmentMasterData, this.search.SearchData);
      //Filter by a column
      // let filteredData=this._filterGridbyColumn(parentGridData,"StartDate",this.searchData);
      //this.parentdata = filteredData;
      $("#DirectInvestmentGrid").data("kendoGrid").dataSource.data(filteredData);
      this.UpdateDirectInvestmentMasterData(true, currentMasterdata);
    },
    AddDirectInvestment: function () {
      this.modalConfig.modalName = "Add Valuation";
      this.modalConfig.modalAddorEdit = "add";      
      var DirectInvestmentAddJSON = {        
        Id: "",
        PartnerId:"",
        PartnerPartnerID:"",
        PartnerFullName:"",
        InvestmentId:"",
        InvestmentInvestmentID:"",
        InvestmentTitle:"",
        TaxYear:"",
        TaxQuarter:"",
        CommitmentFunded:"",
        CommitmentRemaining:"",
        PriorCashDistribution:"",
        ProjectedValue:"",
        CurrentValue:"",
        Note: "",   
      } ;
      
      this.$refs.DirectInvestmentForm.pageErrors=[];
      this.$refs.DirectInvestmentForm.InvestmentAutoCompleteDisplayedValue="";
      this.$refs.DirectInvestmentForm.PartnerAutoCompleteDisplayedValue="";   
      this.$refs.DirectInvestmentForm.getInvestmentAutoCompleteData();
      this.$refs.DirectInvestmentForm.getPartnerAutoCompleteData();
      this.DirectInvestmentJSON = DirectInvestmentAddJSON;
      // this.DirectInvestmentAddJSONId = "";          
      // this.$refs.ProgramInfo.$refs.refProgramForm.errors.clear();             
    },
    EditDirectInvestment: function (e) {
      let self = this;
      e.preventDefault();
      this.modalConfig.modalName = "Edit Valuation";
      this.modalConfig.modalAddorEdit = "edit";
      //alert("Edit button clicked from BaseGrid..");  
      var gview = window.$("#DirectInvestmentGrid").data("kendoGrid");
      // var dataItem1 = gview.dataItem(window.$(e.currentTarget).closest("tr"));
      var dataItem = JSON.parse(JSON.stringify(gview.dataItem(window.$(e.currentTarget).closest("tr"))));      
      this.$refs.DirectInvestmentForm.pageErrors=[];   
      this.$refs.DirectInvestmentForm.InvestmentAutoCompleteDisplayedValue=dataItem.InvestmentTitle;
      this.$refs.DirectInvestmentForm.PartnerAutoCompleteDisplayedValue=dataItem.PartnerFullName;   
      this.$refs.DirectInvestmentForm.getInvestmentAutoCompleteData();
      this.$refs.DirectInvestmentForm.getPartnerAutoCompleteData();
        //alert(JSON.stringify(dataItem));      
      self.DirectInvestmentEditJSON = dataItem;
      self.DirectInvestmentJSON = self.DirectInvestmentEditJSON;       
      
      window.$("#BaseModal").modal("toggle");

    },
    DeleteItemfromGrid: function (e) {
      e.preventDefault();
      //alert("Delete button clicked from BaseGrid..");
      const message = "Are you sure you want to delete this record?";
      this._ConfirmationPopup(message,"DELETE").then((result) => {
        if (result.value) {
          var gview = window.$("#DirectInvestmentGrid").data("kendoGrid");
          var dataItem = gview.dataItem(window.$(e.currentTarget).closest("tr"));                    
          var deleteData = {
            "Id": dataItem.Id
          }
          //let loader = this.$loading.show();
           this._APICrudPopup("APICrudpopup");
          let items = { list:BaseModelDirectInvestmentValuation, payload:deleteData }
          this.DeleteItem(items).then((res) => {
              this.refreshGrid();
            this._AlertPopup("Deleted successfully!","success");
          }).catch(error=>{
              this._AlertPopup("Some Error Occurred!","info");
          }).finally(()=>{
            //loader.hide();
          })
        }
      });
    },

  },
}
</script>
